module.exports = __webpack_public_path__ + "img/jihe1.7939b50d.png";